import { fetchHistoryPaymentPosition1 } from '@/api/business/bankstatement'
import { useQuery } from '@tanstack/react-query'

export const BankStatementHistoryPaymentPosition1Keys = {
    all: ['bankstatementhistorypaymentposition1'] as const,
    lists: () => [...BankStatementHistoryPaymentPosition1Keys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...BankStatementHistoryPaymentPosition1Keys.lists(), page, perPage, filters] as const,
    details: () => [...BankStatementHistoryPaymentPosition1Keys.all, 'detail'] as const,
    detail: (params: string) => [...BankStatementHistoryPaymentPosition1Keys.details(), params] as const,
}

export const useBankStatmentHistoryPaymentPosition1Query = ({ X_CHAVE, X_TYPE, SK_TEMPO_INICIO, SK_TEMPO_FIM, enableStatus }) => {
    return useQuery({
        enabled: enableStatus,
        queryFn: () => fetchHistoryPaymentPosition1({ X_CHAVE, X_TYPE, SK_TEMPO_INICIO, SK_TEMPO_FIM }),
        queryKey: BankStatementHistoryPaymentPosition1Keys.lists(),
    })
}
